import React from 'react';
import { styled } from '@mui/material';
import { Dialog, DialogTitle } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import ErrorMessage from 'components/common/ErrorMessage';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { useDispatch } from 'react-redux';
import { createInterpreterDayOff } from 'slices/interpreter/dashboardSlice';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-container': {
    overflowY: 'auto',
    margin: 'auto',
    alignItems: 'flex-start',
  },
  '& .MuiPaper-root': {
    maxHeight: 'none',
    overflowY: 'hidden',
    borderRadius: 20,
  },
}));

const AddDayOffModal = ({ show, onClose, onSuccess }) => {
  const dispatch = useDispatch();

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: {
      start_date: '',
      end_date: '',
      reason: '',
    },
  });

  const onSubmit = (data) => {
    dispatch(createInterpreterDayOff(data, (success, message) => {
      if (success) {
        toast.success(message, { className: 'successToast' });
        reset();
        onClose();
        if (onSuccess) onSuccess();
      } else {
        toast.error(message || 'Something went wrong', { className: 'errorToast' });
      }
    }));
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <BootstrapDialog
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      open={show}
      sx={{
        '& .MuiDialog-container': { alignItems: 'center' },
        '& .MuiPaper-root': { overflowY: 'visible' },
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="modal-content full_modal">
          <DialogTitle>
            <div className="modal-header header_modal align-items-center">
              <div></div>
              <h5 className="modal-title_u">Add Day Off</h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={handleClose} />
            </div>
          </DialogTitle>

          <div className="modal-body modal_form_body">
            <div className="row-primary row-r">

              <div className="date">
                <h2>Start Date*</h2>
                <Controller
                  name="start_date"
                  control={control}
                  rules={{ required: 'Start date is required' }}
                  render={({ field }) => (
                    <div style={{ width: '100%' }}>
                      <div className="input-image">
                        <input
                          type="date"
                          {...field}
                          placeholder="YYYY-MM-DD"
                        />
                        <img src="/images/celender.png" alt="calendar icon" className="custom-icon" />
                      </div>
                      {errors?.start_date?.message && (
                        <ErrorMessage text={errors.start_date.message} />
                      )}
                    </div>
                  )}
                />
              </div>

              <div className="date">
                <h2>End Date*</h2>
                <Controller
                  name="end_date"
                  control={control}
                  rules={{ required: 'End date is required' }}
                  render={({ field }) => (
                    <div style={{ width: '100%' }}>
                      <div className="input-image">
                        <input
                          type="date"
                          {...field}
                          placeholder="YYYY-MM-DD"
                        />
                        <img src="/images/celender.png" alt="calendar icon" className="custom-icon" />
                      </div>
                      {errors?.end_date?.message && (
                        <ErrorMessage text={errors.end_date.message} />
                      )}
                    </div>
                  )}
                />
              </div>

            </div>

            <div className="row-primary mt-3">
              <h2>Reason</h2>
              <Controller
                name="reason"
                control={control}
                render={({ field }) => (
                  <textarea
                    {...field}
                    className="type_inp input-in"
                    placeholder="Enter reason (optional)"
                  />
                )}
              />
            </div>

            <div className="modal-body d-flex justify-content-end gap-2 mt-2">
              <button type="button" className="Cancle_button" onClick={handleClose}>
                Cancel
              </button>
              <SubmitButton buttonType="submit" btnText="Submit" />
            </div>
          </div>
        </div>
      </form>
    </BootstrapDialog>
  );
};

export default AddDayOffModal;
